import utilityContexts from './utility-contexts.json';

export type AiUtilityContext = {
    applicationSide: string;
    pageName: string;
    pagePurposeLines: string[];
}

export type AiUtilityKey = keyof typeof utilityContexts;

/**
 * Builds a compact, structured utility string that describes
 * the current application/page context for the AI extension.
 */
export const buildUtility = (ctx: AiUtilityContext): string => {
    const { applicationSide, pageName, pagePurposeLines } = ctx;

    return [
        `Application side: ${applicationSide}`,
        `Current page: ${pageName}`,
        'Page purpose:',
        ...pagePurposeLines,
        '',
        'Formatting: Do not use markdown horizontal rules or YAML-style "---" separators in your response. Prefer blank lines or headings instead.',
    ].join('\n');
};

/**
 * Convenience helper: build utility string from a predefined context
 * key plus the concrete entity name (e.g. "SupportClaim").
 */
export const buildUtilityFromKey = (key: string | undefined): string => {
    const rawKey = key ?? 'claimDetails';
    const [baseKey, sideToken] = rawKey.split(':');
    const k = (baseKey as AiUtilityKey) || 'claimDetails';
    const base = utilityContexts[k];

    const applicationSide =
        sideToken === 'Support'
            ? 'Support Application (support team tooling)'
            : sideToken === 'Provider'
            ? 'Provider Application (provider-facing tooling)'
            : 'Unknown';

    if (!base) {
        return buildUtility({
            applicationSide,
            pageName: 'Unknown',
            pagePurposeLines: []
        });
    }

    return buildUtility({
        applicationSide,
        pageName: base.pageName,
        pagePurposeLines: base.pagePurposeLines
    });
};


